import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { ViewerDocument } from 'src/app/_shared/components/viewer-document/viewer-document.component';

export interface ViewerDocumentDialogData {

    viewerDocumentsList: ViewerDocument[];

}

@Component({
    selector: 'app-viewer-document-dialog',
    templateUrl: './viewer-document-dialog.component.html',
    styleUrls: ['./viewer-document-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ViewerDocumentDialogComponent {

    constructor(protected cdr: ChangeDetectorRef,
                private dialogRef: KalDialogRef<ViewerDocumentDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: ViewerDocumentDialogData) {
    }

    get viewerDocumentsList() {
        return this.data.viewerDocumentsList;
    }

    close() {
        this.dialogRef.close();
    }

}
